var exports = {
  "y": "linkedPullRequestLink__QqUA4M",
};

module.exports = exports;
